import React from 'react';
import { Table, Alert } from 'react-bootstrap';
import moment from 'moment';

// Formatação BR (#.##0,00).
const fmtValor = (val) =>
  new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val || 0);

// Taxa de juros — mesmo formato monetário/decimal pt-BR.
const fmtTaxa = (val) =>
  val === null || val === undefined
    ? ''
    : new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
      }).format(val);

const fmtData = (val) => (val ? moment(val).format('DD/MM/YYYY') : '');

const COLSPAN_ANTES_VALORES = 3; // Boleto, Proposta, Data

const TabelaResultado = ({ resultado }) => {
  const familias = (resultado && resultado.familias) || [];
  const totalGeral = (resultado && resultado.total_geral) || {
    saldo: 0,
    custo: 0,
    valor_presente: 0,
  };

  const possuiItens = familias.some(
    (f) => f.itens && f.itens.length > 0
  );

  if (!possuiItens) {
    return (
      <Alert variant="info" className="mt-3">
        Nenhuma informação encontrada.
      </Alert>
    );
  }

  return (
    <div className="mt-3">
      <div style={{ overflowX: 'auto' }}>
        <Table
          striped
          bordered
          hover
          size="sm"
          style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}
        >
          <thead className="thead-dark">
            <tr>
              <th className="text-right" style={{ minWidth: 90 }}>Boleto</th>
              <th className="text-right" style={{ minWidth: 90 }}>Proposta</th>
              <th className="text-center" style={{ minWidth: 100 }}>Data</th>
              <th className="text-right" style={{ minWidth: 130 }}>Saldo</th>
              <th className="text-right" style={{ minWidth: 130 }}>Custo</th>
              <th className="text-right" style={{ minWidth: 130 }}>Valor Presente</th>
              <th className="text-center" style={{ minWidth: 110 }}>Periodicidade</th>
              <th className="text-right" style={{ minWidth: 100 }}>Taxa Juros</th>
              <th className="text-center" style={{ minWidth: 110 }}>Capitaliza Ano</th>
              <th className="text-center" style={{ minWidth: 90 }}>Resíduo</th>
            </tr>
          </thead>
          {familias.map((familia) => {
            const itens = familia.itens || [];
            const subtotal = familia.subtotal || {
              saldo: 0,
              custo: 0,
              valor_presente: 0,
            };

            return (
              <tbody key={`fam-${familia.codigo_familia}`}>
                <tr style={{ backgroundColor: '#dbe7fb' }}>
                  <td colSpan={10}>
                    <strong>{familia.nome_da_familia}</strong>
                  </td>
                </tr>
                {itens.map((item, idx) => (
                  <tr key={`fam-${familia.codigo_familia}-bol-${item.codigo_boleto}-${idx}`}>
                    <td className="text-right">{item.codigo_boleto}</td>
                    <td className="text-right">{item.codigo_proposta}</td>
                    <td className="text-center">{fmtData(item.data)}</td>
                    <td className="text-right">{fmtValor(item.saldo)}</td>
                    <td className="text-right">{fmtValor(item.custo)}</td>
                    <td className="text-right">{fmtValor(item.valor_presente)}</td>
                    <td className="text-center">{item.per_venc}</td>
                    <td className="text-right">{fmtTaxa(item.taxa_juros)}</td>
                    <td className="text-center">{item.cap_ano}</td>
                    <td className="text-center">{item.tem_residuo}</td>
                  </tr>
                ))}
                <tr style={{ backgroundColor: '#eaf0fb' }}>
                  <td colSpan={COLSPAN_ANTES_VALORES} className="text-right">
                    <strong>Subtotal {familia.nome_da_familia}</strong>
                  </td>
                  <td className="text-right">
                    <strong>{fmtValor(subtotal.saldo)}</strong>
                  </td>
                  <td className="text-right">
                    <strong>{fmtValor(subtotal.custo)}</strong>
                  </td>
                  <td className="text-right">
                    <strong>{fmtValor(subtotal.valor_presente)}</strong>
                  </td>
                  <td colSpan={4} />
                </tr>
              </tbody>
            );
          })}
          <tfoot>
            <tr style={{ backgroundColor: '#1a3a6b', color: '#fff' }}>
              <td colSpan={COLSPAN_ANTES_VALORES} className="text-right">
                <strong>Total Geral</strong>
              </td>
              <td className="text-right">
                <strong>{fmtValor(totalGeral.saldo)}</strong>
              </td>
              <td className="text-right">
                <strong>{fmtValor(totalGeral.custo)}</strong>
              </td>
              <td className="text-right">
                <strong>{fmtValor(totalGeral.valor_presente)}</strong>
              </td>
              <td colSpan={4} />
            </tr>
          </tfoot>
        </Table>
      </div>
    </div>
  );
};

export default TabelaResultado;
